<template>
  <div class="type-review">
    <template v-if="$SO.size(hairTypes)">
      <div class="hair-type-wrapper">
        <div v-for="(hair, index) in hairTypes.slice(0, 5)" :key="index" class="hair-type">{{ hair.name }}</div>
        <v-popover v-if="hairTypes.length > 5" placement="bottom-end" offset="5" class="more-review">
          <!-- This will be the popover target (for the events and position) -->
          <div class="tooltip-target more-hair-type">
            <span v-for="i in 3" :key="i"></span>
          </div>
          <!-- This will be the content of the popover -->
          <template slot="popover">
            <p
              v-for="(hair, key) in hairTypes.slice(5, hairTypes.length)" :key="key"
            >
              {{ hair.name.replace(/\,/g, '') }}
            </p>
          </template>
        </v-popover>
      </div>
    </template>
    <template v-else>
      <span class="gray-text">User has not completed the beauty profile</span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'hair-types',
  props: {
    hairTypes: {
      type: Array,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
  @mixin gray-pill() {
    background: #F8F8F8;
    border-radius: 10.5px;
    padding: 2px 8px;
  }
  .hair-type-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 5px;
    .hair-type {
      @include gray-pill();
      font-family: 'Lato-Regular', sans-serif;
      font-size: 12px;
      color: #222222;
      text-align: left;
      line-height: 16px;
    }
    .more-hair-type {
      @include gray-pill();
      padding: 8px 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        background: #F384A7;
        height: 3px;
        width: 3px;
        border-radius: 50%;
        &:not(:last-child) {
          margin-right: 3px;
        }
      }
    }
  }
  .gray-text {
    font-family: 'Lato-Regular', sans-serif;
    font-size: 12px;
    color: #8C8582;
    text-align: left;
    line-height: 12px;
  }
</style>
